import React, {useState, useEffect} from 'react'
import { getGifs } from '../helpers/getGifs';
export const useFetchGifs = (category) => {
  
  const [images, setImages] = useState([]);
  const [isLoading, setIsLoading] = useState(true)
  
    const getImages = async()=>{
      const newImages = await getGifs(category); 
      setImages(newImages);
      setIsLoading(false);
    }

    useEffect(() => {
      getImages()
    }, [])//2o param que es de depednencias vacio y se ejecuta solo la 1a vez la function callback
    
  //sin este return, ya no es un functional component porque ya no regresa jsx
    // return (
    // <div>useFetchGifs</div>
    // )

    return {
        images,
        isLoading
    }

}
